<template>
  <div class="stat-section">
    <div class="row">
      <div class="col-12">
        <UeInlineEditable
          truncate
          class="line1"
          :editable="editable"
          v-model="localSection.line1"
          name="line1"
          placeholder="Qualifier"
          @editable_field:save="updateLine1"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <UeInlineEditable
          truncate
          class="line2"
          :editable="editable"
          v-model="localSection.line2"
          name="line2"
          placeholder="Tagline"
          @editable_field:save="updateLine2"
        />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import SectionMixin from '@app/mixins/case_study_section'

export default {
  name: 'StatSection',
  mixins: [SectionMixin],
  data() {
    return {
      localSection: { ...this.section },
    }
  },
  props: {
    caseStudyId: { type: Number, required: true },
    editable: { type: Boolean, required: false, default: false },
    section: { type: Object, required: true },
    accentColor: { type: String, required: true },
    position: { type: String, required: true },
  },
  watch: {
    section: {
      handler(newSection) {
        this.localSection = { ...newSection }
      },
      deep: true,
    },
  },
  computed: {
    editableText() {
      return this.editable ? true : null
    },
  },
  methods: {
    updateLine1(newContent) {
      this.$emit('stat-updated', this.localSection, 'line1', newContent, this.position)
    },
    updateLine2(newContent) {
      this.$emit('stat-updated', this.localSection, 'line2', newContent, this.position)
    },
  },
}
</script>
<style lang="sass" scoped>
.stat-section
  border: 1px solid #E9ECEF
  border-radius: 14px
  padding: 16px
  overflow: hidden

.line1
  font-size: 32px
  font-weight: 800

.line2
  font-size: 16px
  font-weight: 600
</style>
